<template>
<transition :enter-active-class="'animated fadeInDown'" :leave-active-class="'animated fadeOutUp'">
	<div class="ui-notice-content">
		<template v-if="type === 'message'">
			<div class="ui-notice-content-text" v-html="content"></div>
			<div class="ui-notice-content-text">
			</div>
		</template>
	</div>
</transition>
</template>
<script>
	export default {
		props: {
			type: {
                type: String
            },
            duration: {
                type: Number,
                default: 1.5
            },
			content: {
                type: String,
                default: ''
            },
            onClose: {
                type: Function
            },
            name: {
                type: String,
                required: true
            },
            render: {
                type: Function
            }
		},
		methods: {
			clearCloseTimer () {
                if (this.closeTimer) {
                    clearTimeout(this.closeTimer)
                    this.closeTimer = null
                }
            },
            close () {
            	this.clearCloseTimer()
                this.onClose()
                this.$parent.close(this.name)
            }
		},
		mounted () {
			this.clearCloseTimer()

			if (this.duration !== 0) {
                this.closeTimer = setTimeout(() => {
                    this.close()
                }, this.duration * 1000)
            }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/base/notification/notice.vue